import React from "react";
import { Link } from "react-router";
import { MY_HOST, VN_HOST, PH_BUSINESS_HOST } from "config";
import {
  showFooterCareers,
  showAppSection,
  isPhDomain,
} from "./helpers/domainSettings";
import "./styles/footer.less";

export default class Footer extends React.Component {
  render() {
    return (
      <div id="footer">
        <div className="content">
          <div className="column">
            <Link className="logo" to="/" />
            <div className="country-selector">
              <a className="PH-flag flag" href={PH_BUSINESS_HOST} />
              <a
                className={isPhDomain() ? "hidden" : "VN-flag flag"}
                href={`//${VN_HOST}`}
              />
              <a className="MY-flag flag" href={`//${MY_HOST}`} />
            </div>
          </div>

          <div className="menu column">
            <div className="section">
              <Link className="web-only" to="/how-it-works">
                How It Works
              </Link>
              <Link className="web-only" to="/merchants">
                Merchants
              </Link>
              <Link className="web-only" to="/business">
                For Business
              </Link>
              {showFooterCareers() ? <Link to="/careers">Careers</Link> : null}
            </div>

            <div className="section">
              <Link to="/privacy">Privacy</Link>
              <Link to="/terms">Terms of Use</Link>
              <Link className="web-only" to="/contact">
                Contact
              </Link>
            </div>
          </div>

          <div className="social column">
            <a
              className="icon fb"
              href="https://www.facebook.com/PoweredByZAP"
              target="_blank"
            />
            <a
              className="icon insta"
              href="https://www.instagram.com/poweredbyzap"
              target="_blank"
            />
            <div>2012-{new Date().getFullYear()} All rights reserved.</div>
            {showAppSection() ? (
              <div>
                <a
                  className="icon-app apple"
                  href="https://itunes.apple.com/ph/app/zap-philippines/id907381118"
                  target="_blank"
                />
                <a
                  className="icon-app android"
                  href="https://play.google.com/store/apps/details?id=ph.com.zap.android"
                  target="_blank"
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./js/components/Footer.js